<div class="grid affix affix-top-40">
  <div
    class="link typography typography-paragraph typography-caption grey-600"
    (click)="cleanTags()"
  >
    Сбросить ✕
  </div>
  <div class="grid grid-gutter-8">
    <div *ngFor="let tag of tags$ | async; trackBy: trackBy" class="grid-item">
      <span
        class="link tag tag-m publication-tag"
        [class.active]="tag.checked"
        (click)="toggleTag(tag.id)"
      >
        #{{ tag.name }}
      </span>
    </div>
  </div>
</div>
